export default {
  feedback: {
    login_success: 'Autentificare reușită',
    logout_success: 'Deconectare reușită',
  },
};
